export const CardPlaceholder = () => (
    <div className="card">
        <div className="card-body">
            <div className="card-title placeholder-glow">
                <span className="placeholder col-6"></span>
            </div>

            <div className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
                <span className="placeholder col-4"></span>
                <span className="placeholder col-4"></span>
                <span className="placeholder col-6"></span>
                <span className="placeholder col-8"></span>
            </div>
        </div>
    </div>
);
